import {ReelView} from "../../../core/reel/simplereel/SimpleReelModel";
import {NineToFiveXWaysSymbol} from "./XWaysSymbol";
import {NineToFiveXNudgeSymbol} from "./XNudgeSymbol";
import {NineToFiveScatterSymbol} from "./ScatterSymbol";
import {NineToFiveWildSymbol} from "./WildSymbol";
import {NineToFiveSymbol, SymbolArgs} from "./NineToFiveSymbol";
import {NineToFiveWinCapSymbol} from "./WinCapSymbol";
import {FireSymbol} from "./FireSymbol";
import {LawSuitSymbol} from "./LawSuitSymbol";
import {PaddingSymbol} from "./PaddingSymbol";

export class NineToFiveSymbolFactory {
    // might add spine and sprite pools later on

    constructor() {
    }

    // TODO make into a struct
    createSymbol(args:SymbolArgs):NineToFiveSymbol {
        let newSymbol:NineToFiveSymbol;
        switch(args.symbolName) {
            case "XW":
                newSymbol = new NineToFiveXWaysSymbol(args);
                break;
            case "XN":
                newSymbol = new NineToFiveXNudgeSymbol(args);
                break;
            case "S":
                newSymbol = new NineToFiveScatterSymbol(args);
                break;
            case "W":
                newSymbol = new NineToFiveWildSymbol(args);
                break;
            case "C":
                newSymbol = new NineToFiveWinCapSymbol(args);
                break;
            case "MP":
                newSymbol = new FireSymbol(args);
                break;
            case "MN":
                newSymbol = new LawSuitSymbol(args);
                break;
            case "P":
                newSymbol = new PaddingSymbol(args);
                break;
            default:
                newSymbol = new NineToFiveSymbol(args);
                break;

        }
        return newSymbol;
    }
}
